module.exports = __webpack_public_path__ + "banquet/components/AccountSettings/images/email_toggle.f2cc0e4d926c496b60423c43771760bf.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/images/email_toggle.svg
// module id = 1640
// module chunks = 1